import { useSelector } from "react-redux"
import { selectMediaPlayer } from "../stores/mediaPlayerSlice"

/**
 * Hook to determine if the UniversalPlayer is currently active/shown
 * The player is active when there's a currentMediaItem or items in the queue
 */
export const useIsPlayerActive = () => {
  const mediaPlayerState = useSelector(selectMediaPlayer)

  return !!(
    mediaPlayerState.currentMediaItem || mediaPlayerState.queue.length > 0
  )
}
